"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const IValidation_1 = require("./IValidation");
const Yup = __importStar(require("yup"));
const helper_1 = require("./helper");
exports.workflowReportSchema = Yup.object()
  .shape({
    categories: Yup.array(),
    tabName: Yup.string(),
    transport: Yup.object()
      .shape({
        type: Yup.mixed().required("Please select one notification type"),
        options: Yup.object()
          .shape({
            notifyEmail: Yup.string().when("type", {
              is: "email",
              then: Yup.string()
                .email()
                .required("Please provide email"),
              otherwise: Yup.string()
            }),
            slackConfig: Yup.string().when("type", {
              is: "slack",
              then: Yup.string().required("Please select one option"),
              otherwise: Yup.string()
            })
          })
          .required("Options is required in transport")
      })
      .required("Transport is required")
  })
  .required();
class WorkflowReportNodeValidation {
  validate(node) {
    let data = node.getNodeData();
    return helper_1.isValid(
      [
        { schema: exports.workflowReportSchema, data },
        { schema: IValidation_1.nodeSchema, data: node.serializeNode() }
      ],
      node.getNodeId()
    );
  }
}
exports.WorkflowReportNodeValidation = WorkflowReportNodeValidation;
//# sourceMappingURL=WorkflowReportNodeValidation.js.map
